import { IconButton } from '@festina-life/ui/actions'
import { Icon } from '@festina-life/ui/structure'
import { useState } from 'react'

import { Option } from '../../components/search/commandPalette/Option'
import type {
  SearchableItemGroup,
  SearchableOption,
} from '../../components/search/commandPalette/types'
import { useCommandPaletteLocalStorage } from '../../components/search/commandPalette/useCommandPaletteLocalStorage'
import { renderEntityId } from './helpers'

export type NestedDisplay =
  | 'collapsed'
  | 'expanded'
  | 'expanded-inline'
  | 'child'

type Props = {
  parentView: SearchableOption
  group: SearchableItemGroup
} & SearchableOption['nestedView']

export const RegisteredAction = ({
  action: { entityId },
  nestedChildren,
  parentView,
  group,
}: Props) => {
  const [favourites] = useCommandPaletteLocalStorage()
  const [isActionIdExpanded, setIsActionIdExpanded] = useState(false)

  const shouldHideWarnings = favourites[group].shouldHideWarnings

  const hasMultipleChildren = nestedChildren && nestedChildren.length > 1

  const iconAfterTitle = (
    <div className="flex gap-0.5">
      {hasMultipleChildren ? (
        <IconButton
          iconName={isActionIdExpanded ? 'ChevronDown' : 'ChevronRight'}
          className="size-4"
          extraProps={{
            onMouseDown: (e) => {
              e.stopPropagation()
              setIsActionIdExpanded(!isActionIdExpanded)
            },
            onKeyDown: (e) => {
              const keyToCheck = isActionIdExpanded ? 'ArrowLeft' : 'ArrowRight'
              if (e.key === keyToCheck) {
                e.preventDefault()
                e.stopPropagation()
                setIsActionIdExpanded(!isActionIdExpanded)
              }
            },
          }}
        />
      ) : (
        <>
          <Icon name="ChevronRight" />
          {renderEntityId(entityId)}
        </>
      )}
    </div>
  )

  const nestedChildrenFiltered = shouldHideWarnings
    ? nestedChildren?.filter((x) => x.warnings?.length === 0)
    : nestedChildren

  return (
    <div>
      <Option
        group="command"
        hasNestedChildren
        value={{
          ...parentView,
          action:
            nestedChildren?.length === 1
              ? nestedChildren[0].action
              : () => setIsActionIdExpanded(!isActionIdExpanded),
          presentation: (
            <div className="flex gap-2">
              {parentView.title}
              {iconAfterTitle}
            </div>
          ),
          nestedView: undefined,
        }}
      />
      {isActionIdExpanded && (
        <>
          {nestedChildrenFiltered?.map((child) => (
            <div key={child.title}>
              <Option
                group="command"
                isNested
                comboboxId={`${child.title}-nestedChild`}
                value={{
                  ...child,
                  presentation: (
                    <div className="flex gap-1">
                      <Icon name="ArrowTurnDownRight" />
                      {child.title}
                    </div>
                  ),
                }}
              />
            </div>
          ))}
        </>
      )}
    </div>
  )
}
